module.exports = __webpack_public_path__ + "assets/media/day18.a811d778.mp3";